import { POST } from '~/consts';

export default {
  data() {
    return {
      loading_get_comments_refresh: false,
      loading_get_comments: false,
      disable_loading_get_comments: false,
      dataProvider: {
        page: {
          current: 1,
          limit: 10,
          total: 1,
          next: 2
        }
      },
    }
  },

  methods: {
    onRemoveCommentSuccess() {},
    onRemoveCommentFailed() {},
    removeComment(id) {
      const vm = this;

      if (confirm('Anda yakin ingin menghapus komentar?')) {
        this.$axios.post(POST.REMOVE_COMMENT(id))
          .then(({ data }) => {
            if (data.applicationSystem.code == 0) {
              this.track('comment', 'delete_comment', id)
              vm.onRemoveCommentSuccess(data, id)
            } else {
              vm.onRemoveCommentFailed(data, id)
            }
          })
          .catch(() => {
          });
      }
    },

    onGetCommentsSuccess() {},
    onGetCommentsFailed() {},
    getComments(post_id, refresh = false) {
      const vm = this;

      if (vm.loading_get_comments_refresh || vm.loading_get_comments) {
        return;
      }

      if (refresh) {
        vm.dataProvider.page['current'] = 1
        vm.loading_get_comments_refresh = true
      } else {
        vm.loading_get_comments = true
      }

      this.$axios.post(POST.GET_COMMENTS(post_id), {
        dataProvider: JSON.stringify(vm.dataProvider)
      }).then(({ data }) => {
        if (data.applicationSystem.code == 0) {
          vm.onGetCommentsSuccess(data, refresh);
        } else {
          vm.onGetCommentsFailed();
        }

        vm.loading_get_comments_refresh = false
        vm.loading_get_comments = false
        vm.disable_loading_get_comments = false
      })
      .catch(() => {
        vm.loading_get_comments_refresh = false
        vm.loading_get_comments = false
        vm.disable_loading_get_comments = false
      });
    },
  }
}
